export const REGULAR_PAYSLIP_FIRST_COLUMN_MIN_WIDTH = '220px'

export const REGULAR_PAYSLIP_ROLE_HEADER = 'Role' as const

const REGULAR_PAYSLIP_DAY_TIMING_METAS = [
  { formKey: 'ontime', previewField: 'ontimeDays', headerName: 'Total Ontime' },
  { formKey: 'late_lt_15', previewField: 'lateLt15Days', headerName: 'Total Telat 5-15 Menit' },
  { formKey: 'late_gt_15', previewField: 'lateGt15Days', headerName: 'Total Telat >15 Menit' },
] as const

const REGULAR_PAYSLIP_DAY_ATTENDANCE_METAS = [
  { formKey: 'onleave', previewField: 'leaveDays', headerName: 'Izin' },
] as const

const REGULAR_PAYSLIP_DAY_OVERTIME_METAS = [
  { formKey: 'ot_2_4', previewField: 'overtime2To4', headerName: 'Total Lembur 2-4 Jam' },
  { formKey: 'ot_4', previewField: 'overtime4Plus', headerName: 'Total Lembur >4 Jam' },
  { formKey: 'ho', previewField: 'overtimeHO', headerName: 'Total HO1' },
  { formKey: 'ho2', previewField: 'overtimeHO2', headerName: 'Total HO2' },
] as const

export const REGULAR_PAYSLIP_DAY_COLUMN_METAS = [
  ...REGULAR_PAYSLIP_DAY_TIMING_METAS,
  ...REGULAR_PAYSLIP_DAY_ATTENDANCE_METAS,
  ...REGULAR_PAYSLIP_DAY_OVERTIME_METAS,
] as const

export const REGULAR_PAYSLIP_DAY_FORM_KEYS = REGULAR_PAYSLIP_DAY_COLUMN_METAS.map(
  (meta) => meta.formKey,
)

const REGULAR_PAYSLIP_INCOME_RATE_METAS = [
  {
    previewField: 'dailyCommissionFormatted',
    headerName: 'Rate Harian',
    pendapatanAmountKey: 'harian' as const,
  },
  {
    previewField: 'overtime2To4Formatted',
    headerName: 'Rate Lembur 2-4 Jam',
    pendapatanAmountKey: 'lembur_2_4' as const,
  },
  {
    previewField: 'overtime4PlusFormatted',
    headerName: 'Rate Lembur >4 Jam',
    pendapatanAmountKey: 'lembur_4' as const,
  },
  {
    previewField: 'overtimeHOFormatted',
    headerName: 'Rate Lembur HO1',
    pendapatanAmountKey: 'ho' as const,
  },
  {
    previewField: 'overtimeHO2Formatted',
    headerName: 'Rate Lembur HO2',
    pendapatanAmountKey: 'ho2' as const,
  },
] as const

export const REGULAR_PAYSLIP_INCOME_COLUMN_METAS = [...REGULAR_PAYSLIP_INCOME_RATE_METAS] as const

export const VALIDATE_PAYSLIP_DAY_COLUMNS: readonly string[] = [
  REGULAR_PAYSLIP_ROLE_HEADER,
  ...REGULAR_PAYSLIP_DAY_COLUMN_METAS.map((meta) => meta.headerName),
]

export const VALIDATE_PAYSLIP_INCOME_COLUMNS: readonly string[] = [
  REGULAR_PAYSLIP_ROLE_HEADER,
  ...REGULAR_PAYSLIP_INCOME_COLUMN_METAS.map((meta) => meta.headerName),
]
